<template>

    <CHeader fixed with-subheader light style="border-top: 3px solid #00acc1 ">

        <vue-snotify></vue-snotify>

        <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <CHeaderBrand class="mx-auto d-lg-none" to="/">
      <CIcon name="logo" height="48" alt="Logo"/>
    </CHeaderBrand>
    <CHeaderNav class="d-md-down-none mr-auto" >
      <CHeaderNavItem class="px-3">
<!--        <CHeaderNavLink to="/wall">-->
<!--            Wall-->
<!--        </CHeaderNavLink>-->
      </CHeaderNavItem>

        <CHeaderNavItem class="px-3">
<!--            <CHeaderNavLink to="/sprints" exact>-->
<!--                Sprints-->
<!--            </CHeaderNavLink>-->
        </CHeaderNavItem>


      <CHeaderNavItem class="px-3">
<!--        <CHeaderNavLink to="/boards" exact>-->
<!--          Boards-->
<!--        </CHeaderNavLink>-->
      </CHeaderNavItem>
      <CHeaderNavItem class="px-3">
<!--        <CHeaderNavLink to="/dashboard">-->
<!--            Dashboard-->
<!--        </CHeaderNavLink>-->
      </CHeaderNavItem>
    </CHeaderNav>
    <CHeaderNav class="mr-4">
      <CHeaderNavItem class="d-md-down-none mx-2">
<!--        <CHeaderNavLink>-->
<!--          <CIcon name="cil-bell"/>-->
<!--            -->
<!--        </CHeaderNavLink>-->

          <TheHeaderNotifications/>


      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-list"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <CHeaderNavItem class="d-md-down-none mx-2">
        <CHeaderNavLink>
          <CIcon name="cil-envelope-open"/>
        </CHeaderNavLink>
      </CHeaderNavItem>
      <TheHeaderDropdownAccnt/>
    </CHeaderNav>
    <CSubheader class="px-3">
      <CBreadcrumbRouter class="border-0 mb-0"/>
    </CSubheader>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from './TheHeaderDropdownAccnt'
import TheHeaderNotifications from './TheHeaderNotifications'

export default {
  name: 'TheHeader',
  components: {
    TheHeaderDropdownAccnt,
    TheHeaderNotifications

  }
}
</script>
